import * as React from "react";
import PropTypes from "prop-types";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    root: {
        width: '100%',
    }
});

class TAccordian extends React.Component {

    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        items                 : PropTypes.array,
        content               : PropTypes.array,
        outerStyle            : PropTypes.object,
        style                 : PropTypes.object,
        summaryStyle          : PropTypes.object,
        expanded              : PropTypes.array,
        onExpansionPanelClick : PropTypes.func,
    };

    static defaultProps = {
        items                 : ['Header 1', 'Header 2', 'Header 3'],
        content               : [<Typography>Content 1</Typography>, <Typography>Content 2</Typography>, <Typography>Content 3</Typography>],
        outerStyle            : {},
        style                 : {},
        summaryStyle          : {},
        expanded              : [],
        onExpansionPanelClick : () => console.log("onExpansionPanelClick"),
    };

    onExpansionPanelClick = (event, expanded) => {
        this.props.onExpansionPanelClick(expanded, event, this.props.info);
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderContent = (items) => {
        return items;
    };

    renderPanels = () => {

        let s = [];

        for (let i = 0; i < this.props.items.length; i++) {

            const expandedDefined = typeof this.props.expanded[i] !== "undefined";

            s.push(
                <ExpansionPanel
                    style={{
                        borderTop: '1px solid rgb(220, 220, 220)',
                        ...this.props.style
                    }}
                    key={'Accordian' + i}
                    defaultExpanded={expandedDefined ? this.props.expanded[i] : false}
                    onChange={this.onExpansionPanelClick}
                >
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={styles.heading} style={this.props.summaryStyle}>{this.props.items[i]}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{ display: 'block' }}>
                        {this.renderContent(this.props.content[i])}
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            );
        }

        return s;
    };

    render() {

        return (
            <div
                style = {{
                    //width: '100%',
                    ...this.props.outerStyle,
                }}
            >
                {this.renderPanels()}
            </div>
        );
    }
}

export default TAccordian;